export enum AiChatbotView {
  Start,
  NewChat,
  ChatsHistory,
  ChatDetails,
  Settings,
}
